import React from 'react';
import { useTranslation } from 'react-i18next';
import { Item } from '../../../../graphql/graphql';
import { ItemCard } from '../../../ui/ItemCard';
import { useBookmarks } from '../../../../hooks/useBookmarks';
import { Button } from '../../../ui/Button';
import { withEndlessScroll } from '../../../HOC/endlessScroll';
import ProfileInvoicesList from '../../../Profile/ProfileInvoices/ProfileInvoicesList';
import { PanelContent } from '../../../ItemsMap/MapSidePanel/styled';
import useScreenSize from '../../../../hooks/useScreenSize';
import { ModalContent } from '../../../ItemsMap/MapItemModal/styled';
import { SectionPlaceholder } from '../../../Placeholders/SectionPlaceholder';
import { ItemCardPlaceholder } from '../../../Placeholders/ItemCardPlaceholder';
import { buttonStyles, PlaceholderWrapper } from './styled';

interface ItemsListProps {
  items: Item[];
  isClusterMarker: boolean;
  loading: boolean;
  hasNextPage?: boolean;
  onLoadMore: () => void;
}

const listRef = React.createRef<HTMLDivElement>();
const EndlessItemsList = withEndlessScroll(ProfileInvoicesList);

export const ItemsList: React.FC<ItemsListProps> = ({
  items,
  isClusterMarker,
  loading,
  hasNextPage,
  onLoadMore
}) => {
  const { t } = useTranslation();
  const { isBookmarked } = useBookmarks();
  const { isSmallOrLargeDesktop } = useScreenSize();

  const ComponentWrapper = isSmallOrLargeDesktop ? PanelContent : ModalContent;
  const itemsList = items.map(item => (
    <ItemCard
      key={item.id}
      {...item}
      inBookmarks={isBookmarked(item.id)}
      button={<Button text={t('new_search.view_ad')} styles={buttonStyles} />}
    />
  ));

  if (!items.length && loading) {
    return (
      <ComponentWrapper>
        <PlaceholderWrapper>
          <SectionPlaceholder column noHeader>
            {Array.from({ length: isClusterMarker ? 3 : 1 }, (_, index) => (
              <ItemCardPlaceholder key={index} isCardsLayout />
            ))}
          </SectionPlaceholder>
        </PlaceholderWrapper>
      </ComponentWrapper>
    );
  }

  if (!isClusterMarker) {
    return <ComponentWrapper>{itemsList}</ComponentWrapper>;
  }

  return (
    <ComponentWrapper ref={listRef}>
      <EndlessItemsList
        ref={listRef}
        items={itemsList}
        loading={loading}
        isStopLoad={!hasNextPage}
        onLoadMore={onLoadMore}
        scrollContainer="parent"
      >
        {itemsList}
      </EndlessItemsList>
    </ComponentWrapper>
  );
};
